/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {ContractDTO} from './contract-dto.model';
import {DelAccountVoModel} from './del-account-vo.model';

export class ServiceProviderContractDTO extends JSONable {
  uuid: string | undefined = undefined;
  contractDTO: ContractDTO | undefined = undefined;
  accountVO: DelAccountVoModel | undefined = undefined;
}
